import { action } from 'typesafe-actions';
import ActionTypes from './constants';

export const setLocationManagementId = (locationId: string) =>
  action(ActionTypes.SET_LOCATION_MANAGEMENT_ID, locationId);
